<template>
  <div>
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="物料名称">
          <el-input size="small" v-model="searchForm.name" placeholder="请输入物料名称"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button size="small" type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--添加产品分类-->
    <div class="common-level-rail">
      <el-button size="small" type="primary" @click="addClick" icon="el-icon-plus">添加物料</el-button>
    </div>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column prop="name" label="物料名称"  align="center">
      </el-table-column>
      <el-table-column prop="materialStock" label="库存" align="center">
      </el-table-column>
      <el-table-column prop="materialPrice" label="价格" align="center">
      </el-table-column>
      <!-- <el-table-column prop="material.name" label="分类" align="center"> </el-table-column> -->
      <el-table-column prop="createTime" label="创建时间" align="center"> </el-table-column>
      <el-table-column fixed="right" label="操作" align="center" width="180">
        <template slot-scope="scope">
          <!-- <el-button @click="handleClick(scope.row)" type="text" size="small"
            >查看详情</el-button
          > -->
          <el-button type="primary" size="small" @click="toupdate(scope.row)">编辑</el-button>
          <el-button type="danger" size="small" @click="toedit(scope)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <div class="pagination">
      <el-pagination @current-change="handleCurrentChange" background :current-page="curPage" :page-size="pageSize" layout="total, prev, pager, next" :total="totalDataNumber"></el-pagination>
    </div>
    <!--添加-->
    <Add v-if="open_add" :open_add="open_add" :addform="categoryModel" @closeDialog="closeDialogFunc($event, 'add')"></Add>
    <Edit v-if="open_add1" :open_add1="open_add1" :addform="addform" :materialId="materialId" @closeDialog="closeDialogFunc($event, 'edit')"></Edit>
  </div>
</template>

<script>
import materialApi from "@/api/material.js";
import Add from "./Add.vue";
import Edit from "./edit.vue";

export default {
  components: {
    Add,
    Edit
  },
  data() {
    return {
      /*当前编辑的对象*/
      categoryModel: {
        catList: [],
        model: {}
      },
      /*是否打开添加弹窗*/
      open_add: false,
      open_add1: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 4,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      searchForm: {
        name: ""
      },
      materialId: "",
      tableData: [],
      addform:{}
    };
  },
  created() {
    this.getData();
    this.getcate();
  },
  methods: {
    onSubmit() {
      this.curPage = 1;
      this.getData();
    },
    /*获取列表*/
    getData() {
      let self = this;
      let Params = self.searchForm;
      Params.pageIndex = self.curPage;
      Params.pageSize = self.pageSize;
      self.loading = true;
      materialApi
        .productList(Params, true)
        .then(data => {
          console.log(data.data,'所有数据');
          self.loading = false;
          self.tableData = data.data.data;
          self.totalDataNumber = data.data.total;
          console.log(data.data);
        })
        .catch(error => {
          self.loading = false;
        });
    },
    getcate() {
      let self = this;
      materialApi
        .catList({}, true)
        .then(data => {
          console.log(data.data);
          self.categoryModel.catList = data.data
          // self.categoryModel.catList = self.tableData;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    /*选择第几页*/
    handleCurrentChange(val) {},
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      console.log(e, f);
      if (f == "add") {
        this.open_add = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
      if (f == "edit") {
        this.open_add1 = e.openDialog;
        if (e.type == "success") {
          this.getData();
        }
      }
    },
    handleClick(row) {
      console.log(row);
    },
    /*打开添加*/
    addClick() {
      this.open_add = true;
    },
    toupdate(e) {
      console.log(e);
      this.addform=e
      this.addform.catList=this.categoryModel.catList
      // this.materialId = e.materialId;
      this.open_add1 = true;
    },
    toedit(e) {
      console.log(e);
      let self = this;
      materialApi
        .delProduct(
          {
            materialId: e.row.materialId
          },
          true
        )
        .then(data => {
          self.$message({
            message: data.msg,
            type: "success"
          });
          self.getData();
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/views/materials/materials/index.vue